import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import PaymentResult from "@/pages/PaymentResult";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Plan, { PlanResult } from "@/pages/Plan";
import Tenants from "@/pages/Tenants";
import Guide from "@/pages/Guide";
import Reconciliations from "@/pages/Reconciliations";
import Dashboard from "@/pages/Dashboard";
import Accounts from "@/pages/Accounts";
import AccountDetail from "@/pages/AccountDetail";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import DocList from "@/pages/DocList";
import DocForm from "@/pages/DocForm";
import DocDetail from "@/pages/DocDetail";
import Payments from "@/pages/Payments";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Reminders from "@/pages/Reminders";
import AccountContacts from "@/pages/AccountContacts";
import Notes from "@/pages/Notes";
import Shipments from "@/pages/Shipments";
import Help from "@/pages/Help";
import ActivityLog from "@/pages/ActivityLog";
import AcceptInvitation from "@/pages/AcceptInvitation";
import Reconciliation from "@/pages/Reconciliation";
import Waybill from "@/pages/Waybill";
import InvoiceDoc from "@/pages/InvoiceDoc";
import InvoiceBulkPrint from "@/pages/InvoiceBulkPrint";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return <div className="flex h-screen items-center justify-center label-eyebrow" data-testid="auth-loading">Yükleniyor…</div>;
  }
  return user ? children : <Navigate to="/login" replace state={{ from: `${loc.pathname}${loc.search}` }} />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/kayit" element={<Register />} />
            <Route path="/davet" element={<AcceptInvitation />} />
            <Route path="/mutabakat/:token" element={<Reconciliation />} />
            <Route path="/odeme/sonuc" element={<PaymentResult />} />
            <Route path="/odeme/iptal" element={<PaymentResult cancelled />} />
            <Route path="/irsaliye/:id" element={<Protected><Waybill /></Protected>} />
            <Route path="/fatura/:id" element={<Protected><InvoiceDoc /></Protected>} />
            <Route path="/faturalar-yazdir" element={<Protected><InvoiceBulkPrint /></Protected>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="cariler" element={<Accounts />} />
              <Route path="cariler/:id" element={<AccountDetail />} />
              <Route path="stok" element={<Products />} />
              <Route path="stok/:id" element={<ProductDetail />} />
              <Route path="siparisler" element={<DocList mode="order" />} />
              <Route path="siparisler/yeni" element={<DocForm mode="order" />} />
              <Route path="siparisler/:id" element={<DocDetail mode="order" />} />
              <Route path="faturalar" element={<DocList mode="invoice" />} />
              <Route path="faturalar/yeni" element={<DocForm mode="invoice" />} />
              <Route path="faturalar/:id" element={<DocDetail mode="invoice" />} />
              <Route path="kasa" element={<Payments />} />
              <Route path="raporlar" element={<Reports />} />
              <Route path="hatirlatmalar" element={<Reminders />} />
              <Route path="cari-iletisim" element={<AccountContacts />} />
              <Route path="cek-senet" element={<Notes />} />
              <Route path="sevkiyatlar" element={<Shipments />} />
              <Route path="yardim" element={<Help />} />
              <Route path="ayarlar" element={<Settings />} />
              <Route path="islem-gecmisi" element={<ActivityLog />} />
              <Route path="plan" element={<Plan />} />
              <Route path="plan/sonuc" element={<PlanResult />} />
              <Route path="sirketler" element={<Tenants />} />
              <Route path="rehber" element={<Guide />} />
              <Route path="mutabakatlar" element={<Reconciliations />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
